<template>
	<b-modal ref="modalIntraLocation" @hidden="resetModal">
		<template slot="modal-header" slot-scope="{ close }">
			<h2 class="mx-auto my-auto">{{ $t('intra_location.ajouter') }}</h2>
			<i class="btn btn-link my-auto" @click="close()"><font-awesome-icon :icon="['fal', 'times-circle']" /></i>
		</template>
		<template slot="default">
			<div class="row">
				<div class="col-12" v-if="form_message !== ''">
				    <ErrorAlert :messageI18n="form_message" />
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<label for="intra_location_parent">{{ $t('intra_location.location_parent') }} *</label>
					<e-select
						v-model="form.intralocation_parent"
						id="intra_location_parent"
						track-by="uuid"
						label="intralocation_label"
						:placeholder="$t('intra_location.rechercher_localisation')"
						:selectedLabel="$t('global.selected_label')"
						:options="intra_locations"
						:searchable="true"
						:show-labels="false"
						:allow-empty="false"
						class="form-group"
						:class="{ 'is-invalid': errors && errors.indexOf('no parent') > -1 }"
					>
						<template slot="option" slot-scope="props"><span :style="`padding-left: ${25 * (props.option.indent || 0) }px;`">{{ props.option.intralocation_label }}</span></template>
					</e-select>
				</div>

				<div class="col-12">
					<div class="form-group">
						<label for="libelle">{{ $t('intra_location.location_label') }}</label>
						<input
							id="libelle"
							type="text"
							class="form-control"
							:placeholder="$t('intra_location.location_label')"
							:class="{ 'is-invalid': errors && errors.indexOf('no label') > -1 }"
							v-model="form.intralocation_label"
						>
					</div>
				</div>

				<div class="col-12">
					<label for="intra_location_type">{{ $t('intra_location.location_type') }}</label>
					<e-select
						v-model="form.intralocation_type"
						id="intra_location_type"
						track-by="code"
						label="label"
						:placeholder="$t('intra_location.rechercher_type')"
						:selectedLabel="$t('global.selected_label')"
						:options="types"
						:searchable="true"
						:show-labels="false"
						:allow-empty="false"
						:class="{ 'is-invalid': errors && errors.indexOf('no type') > -1 }"
						class="form-group"
					/>
				</div>

				<div class="col-12">
					<div class="form-group row">
						<div class="col-6">
							<label for="size">{{ $t('intra_location.taille') }}</label>
							<b-form-input 
								id="size" 
								type="text" 
								number
								v-model="form.intralocation_size"
								:placeholder="$t('intra_location.taille')"
							></b-form-input>
						</div>
						<div class="col-6">
							<label for="nb_horses">{{ $t('intra_location.nb_horses') }}</label>
							<b-form-input 
								id="nb_horses" 
								type="text" 
								number
								v-model="form.intralocation_horses"
								:placeholder="$t('intra_location.taille')"
							></b-form-input>
						</div>
					</div>
				</div>
			</div>
		</template>

		<template slot="modal-footer" class="justify-content-center">
			<b-button variant="primary" @click="saveForm()" :disabled="processing">
				<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
				{{ $t('global.enregistrer') }}
			</b-button>
		</template>
	</b-modal>
</template>

<script type="text/javascript">
    import Common from '@/assets/js/common.js'
	import IntraLocation from '@/mixins/IntraLocation'
	import _cloneDeep from 'lodash/cloneDeep'

	export default {
		name: 'AddModal',
		props: {
			intraLocationId: { type: Number, default: 0 }
		},
		mixins: [IntraLocation],
		data () {
			return {
				intralocation_id: 0,
				processing: false,
				form_message: '',
				intra_locations: [],
				types: [],
				errors: [],

				form: null,
				default_form: {
					intralocation_label	  : '',
					intralocation_horses  : 0,
					intralocation_type    : null,
					intralocation_size    : 0,
					intralocation_parent  : null
				},
			}
		},

		created() {
			this.preinit_component()
		},

		methods: {
			async preinit_component() {
				this.resetModal()

				// On récupére les résidences et localisations internes liées
				this.getIntraLocationsWithresidences(true, false)
					.then(res => (this.intra_locations = res))

				this.getIntraLocationTypes()
					.then(res => (this.types = res))
			},

			async saveForm() {
				if(!this.processing)
				{
					this.errors = []
					this.form_message = ''

					if(!this.form.intralocation_label) {
						this.form_message = 'intra_location.need_label'
						this.errors.push('no label')
					}
					if(!this.form.intralocation_type) {
						this.form_message = 'intra_location.need_type'
						this.errors.push('no type')
					}

					if(!this.form.intralocation_parent) {
						this.form_message = 'intra_location.need_parent'
						this.errors.push('no parent')
					}

					// A la moindre erreur observée, on skip
					if(this.form_message != '') return
					this.processing = true

					const temp = _cloneDeep(this.form)
					temp.intralocation_type = this.form.intralocation_type.id
					temp.intralocation_parent  = this.form.intralocation_parent.intralocation_id
					temp.intralocation_is_root = this.form.intralocation_parent.intralocation_is_root
					
					temp.old_intralocation = {
						intralocation_horses: 0,
						intralocation_size: 0
					}

					if(this.intralocation_id == 0) {
						await this.addIntraLocation(temp)
					}
					else {
						temp.intralocation_id = this.intralocation_id
						await this.updateIntraLocation([temp])
					}
					
					this.processing = false
					this.successModal()
				}
			},

			openModal(location=null) {
				if(location) {
					this.intralocation_id = location.intralocation_id
					this.form.intralocation_label	= location.intralocation_label,
					this.form.intralocation_horses  = location.intralocation_horses,
					this.form.intralocation_type    = location.intralocation_type,
					this.form.intralocation_size    = location.intralocation_size,
					this.form.intralocation_parent  = this.intra_locations.find(il => il.intralocation_id == location.intralocation_parent)
				}

				this.$refs.modalIntraLocation.show()
			},

			resetModal() {
				this.form = _cloneDeep(this.default_form)
				this.intralocation_id = 0

				if(this.intra_locations.length > 0)
					this.form.intralocation_parent = this.intra_locations[0]
			},

			successModal() {
				this.$emit('ok')
				this.$refs.modalIntraLocation.hide()
				this.preinit_component()
			}
		},

		components: {
            ErrorAlert: () => import('GroomyRoot/components/Alert/ErrorAlert'),
		}
	}

</script>